import { createLogger } from 'redux-logger';

export const logger = createLogger({
  collapsed: true,
  predicate: (getState, action) => {
    const config = getState().config;

    // Never log actions in test environment
    if (navigator.userAgent.includes('jsdom')) return false;

    // Never log these specific actions (mostly because are too frecuent)
    switch (action.type) {
      case '@action.player.setPlaybackCurrentTime':
      case '@action.player.setPlaybackLoadProgressTime':
      case '@action.player.setPlayerControlsVisible':
      case '@action.player.addCues':
      case '@action.vhs.setHeartbeatCount':
      case '@actionOn.player.onPlayerControlsVisibileChange':
      case '@thunk.player.checkBuffering':
      case '@thunk.player.checkFramerateAndBitrate':
      case '@thunk.player.checkAudioTrackSelected':
      case '@thunk.player.handleVideoTimeUpdate':
      case '@thunk.vhs.tickHeartbeat':
      case '@thunk.vhs.tickHeartbeat(start)':
      case '@thunk.vhs.tickHeartbeat(success)':
      case '@thunk.subtitles.loadSubtitleCuesFromHlsjs':
      case '@thunkOn.player.onProgress':
      case '@thunkOn.player.onPlayerProgress':
        return false;
    }

    // Skip 'start' and 'success' thunk logs, only log the main thunk call
    if (/\((start|success)\)/.test(action.type)) return false;

    // Forward the action to host application (skip Easy Peasy thunk functions)
    if (
      typeof config.onAnyActionCallback === 'function' &&
      typeof action === 'object' &&
      action != null &&
      typeof action.type === 'string'
    ) {
      config.onAnyActionCallback(action);
    }

    if (config.logging) {
      console.groupCollapsed(`Trace ${action.type}`);
      console.trace(action.type);
      console.groupEnd();
      return true;
    }

    return false;
  },
});
